export { default } from './GridTrendingButton';
